import { memo, useState } from 'react'
import classNames from 'classnames'

import {
  useAsyncCallback,
  useContentOverflow,
  useMouseHover,
} from '../../../hooks'
import { getQaSelector } from '../../../utils/common'
import { toCSSPixel } from '../../../utils/styles'
import { FloatingTooltip } from '../../Floating'
import Text from '../../Text'
import { TableHeaderRowCellSortingButton } from '../TableHeaderRowCellSortingButton'

import { QA_NAME_TABLE_HEADER_CELL_CONTEXT } from './TableHeaderRowCell.constants'
import { getSortingOptions } from './TableHeaderRowCell.utils'

import * as styles from './TableHeaderRowCell.module.css'

function TableHeaderRowCell(props) {
  const {
    className = styles.TableHeaderRowCell,
    columnName,
    isActive,
    isResizing,
    ordering,
    orderingField,
    resizable = true,
    showCellBorder,
    title,
    width,
  } = props

  const [isLoading, setLoading] = useState(false)

  const [ref, isHovered] = useMouseHover()

  const { overflow, setContentOverflowRef } = useContentOverflow()

  const sortingOptions = getSortingOptions(orderingField)

  const handleClick = useAsyncCallback(
    (orderingField, sortingDirection) => {
      setLoading(true)

      return props.onClick(orderingField, sortingDirection).finally(() => {
        setLoading(false)
      })
    },
    [props.onClick]
  )

  const cellClassName = classNames(className, {
    [styles.resizing]: isResizing,
    [styles.withBorder]: showCellBorder,
  })

  const pipClassName = classNames(styles.pip, {
    [styles.active]: isActive,
    [styles.resizing]: isResizing,
  })

  const qaPropsCell = getQaSelector({
    context: QA_NAME_TABLE_HEADER_CELL_CONTEXT,
    def: QA_NAME_TABLE_HEADER_CELL_CONTEXT,
    value: columnName,
  })

  return (
    <div
      {...qaPropsCell}
      className={cellClassName}
      ref={ref}
      style={{ width: toCSSPixel(width) }}
    >
      {resizable ? (
        <div
          className={pipClassName}
          id={columnName}
          onPointerDown={props.onResize}
        />
      ) : null}
      {orderingField ? (
        <TableHeaderRowCellSortingButton
          disabled={isResizing}
          isHovered={isHovered}
          isLoading={isLoading}
          options={sortingOptions}
          ordering={ordering}
          orderingField={orderingField}
          text={title}
          onClick={handleClick}
        />
      ) : (
        <FloatingTooltip content={title} disabled={!overflow}>
          <Text
            isSecondary
            className={styles.headerText}
            ref={setContentOverflowRef}
          >
            {title}
          </Text>
        </FloatingTooltip>
      )}
    </div>
  )
}

export default memo(TableHeaderRowCell)
